<template>
  <div class="card w-[250px] fixed rounded-none z-40">
    <div class="bg-black min-h-screen py-5 px-2">
      <div class="flex">
        <button
          @click="closeNav"
          class="ml-5 bg-secondary text-white py-2 px-4 hover:bg-indigo rounded-full cursor-pointer"
        >
          x
        </button>
      </div>

      <nav class="flex flex-col justify-evenly min-h-screen">
        <!-- <div class="h-full w-[80px] mx-auto">
          <router-link to="/"
            ><img src="/images/logo-white.png" alt="lubxoil logo"
          /></router-link>
        </div> -->
        <ul class="flex flex-col items-center gap-10">
          <router-link to="/home">
            <li
              @click="closeNav"
              class="capitalize text-xs md:text-sm lg:text-lg cursor-pointer hover:text-secondary"
              :class="active.includes('home') ? 'text-secondary' : 'text-white'"
            >
              Home
            </li></router-link
          >
          <router-link to="/about"
            ><li
              @click="closeNav"
              class="capitalize text-xs md:text-sm lg:text-lg cursor-pointer hover:text-secondary"
              :class="
                active.includes('about') ? 'text-secondary' : 'text-white'
              "
            >
              About Us
            </li></router-link
          >
          <li
            class="capitalize text-white text-xs md:text-sm lg:text-lg cursor-pointer hover:text-secondary"
          >
            <popper
              arrow
              :hover="true"
              :placement="'bottom'"
              class="hover:text-secondary"
              :class="
                active.includes('products') ? 'text-secondary' : 'text-white'
              "
            >
              products

              <template #content>
                <div class="w-[200px] my-2">
                  <router-link to="/products/automobile">
                    <div
                      @click="closeNav"
                      class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades border-b"
                      :class="
                        active.includes('automobile') ? 'bg-secondary' : ''
                      "
                    >
                      Automobile Oils
                    </div></router-link
                  >
                  <router-link to="/products/industrial">
                    <div
                      @click="closeNav"
                      class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades border-b"
                      :class="
                        active.includes('industrial') ? 'bg-secondary' : ''
                      "
                    >
                      Industrial Oils
                    </div></router-link
                  >
                  <router-link to="/products/greases">
                    <div
                      @click="closeNav"
                      class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades border-b"
                      :class="active.includes('greases') ? 'bg-secondary' : ''"
                    >
                      Greases
                    </div></router-link
                  >
                  <router-link to="/products/quality-control">
                    <div
                      @click="closeNav"
                      class="text-black py-3 px-5 cursor-pointer lg:text-lg hover:bg-secondary-shades"
                      :class="
                        active.includes('quality-control') ? 'bg-secondary' : ''
                      "
                    >
                      Quality Control
                    </div></router-link
                  >
                </div>
              </template>
            </popper>
          </li>
          <router-link to="/careers"
            ><li
              @click="closeNav"
              class="capitalize text-xs md:text-sm cursor-pointer lg:text-lg hover:text-secondary"
              :class="
                active.includes('careers') ? 'text-secondary' : 'text-white'
              "
            >
              Careers
            </li></router-link
          >
          <router-link to="/contact">
            <li
              @click="closeNav"
              class="capitalize text-xs md:text-sm cursor-pointer lg:text-lg hover:text-secondary"
              :class="
                active.includes('contact') ? 'text-secondary' : 'text-white'
              "
            >
              Contact
            </li></router-link
          >
        </ul>
        <div @click="closeNav" class="mx-auto">
          <a href="/docs/product-cert.pdf" download>
            <button
              class="border border-secondary py-2 px-5 rounded text-xs text-capitalize text-secondary hover:bg-secondary hover:text-white"
            >
              products certificate
            </button>
          </a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    //
  },

  data() {
    return {};
  },

  methods: {
    closeNav() {
      // Emitting a custom event with the name 'button-clicked'
      this.$emit("close-button");
    },
  },

  computed: {
    active() {
      return this.$route.path;
    },
  },
};
</script>
